module.exports = __webpack_public_path__ + "img/dropdown-search-lincoln.3e20aec1.png";